import * as actionTypes from '../actions/actionTypes'

const initialStateUrlName = {
    data: false,
    error: null,
}

const initialStateListCountries = {
    data: {},
    error: null,
}

const initialStateListTimezone = {
    data: {},
    error: null,
}

const initialStateListLanguages = {
    data: {},
    error: null,
}

const initialStateListIndustries = {
    data: {},
    error: null,
}

const initialStateListProfiles = {
    data: {},
    error: null,
}

const initialStateListRoles = {
    data: {},
    error: null,
}

export const validateUrlName = (state = initialStateUrlName, action) => {
    switch (action.type) {
        case actionTypes.VALIDATE_TENANT_NAME_SUCCESS:
            const data  = action.payload;
            return { ...state, data };
        case actionTypes.VALIDATE_TENANT_NAME_ERROR:
            return { ...state, data: [], error: action.payload };
        default:
            return state
    }
}

export const listCountries = (state = initialStateListCountries, action) => {
    switch (action.type) {
        case actionTypes.LIST_COUNTRIES_SUCCESS:
            const data  = action.payload;
            return { ...state, data };
        case actionTypes.LIST_COUNTRIES_ERROR:
            return { ...state, data: [], error: action.payload };
        default:
            return state
    }
}

export const listTimezones = (state = initialStateListTimezone, action) => {
    switch (action.type) {
        case actionTypes.LIST_TIMEZONE_SUCCESS:
            const data  = action.payload;
            return { ...state, data };
        case actionTypes.LIST_TIMEZONE_ERROR:
            return { ...state, data: [], error: action.payload };
        default:
            return state
    }
}

export const listLanguages = (state = initialStateListLanguages, action) => {
    switch (action.type) {
        case actionTypes.LIST_LANGUAGES_SUCCESS:
            const data  = action.payload;
            return { ...state, data };
        case actionTypes.LIST_LANGUAGES_ERROR:
            return { ...state, data: [], error: action.payload };
        default:
            return state
    }
}

export const listIndustries = (state = initialStateListIndustries, action) => {
    switch (action.type) {
        case actionTypes.LIST_INDUSTRIES_SUCCESS:
            const data  = action.payload;
            return { ...state, data };
        case actionTypes.LIST_INDUSTRIES_ERROR:
            return { ...state, data: [], error: action.payload };
        default:
            return state
    }
}

export const listProfiles = (state = initialStateListProfiles, action) => {
    switch (action.type) {
        case actionTypes.LIST_PROFILES_SUCCESS:
            const data  = action.payload;
            return { ...state, data };
        case actionTypes.LIST_PROFILES_ERROR:
            return { ...state, data: [], error: action.payload };
        default:
            return state
    }
}

export const listRoles = (state = initialStateListRoles, action) => {
    switch (action.type) {
        case actionTypes.LIST_ROLES_SUCCESS:
            const data  = action.payload;
            return { ...state, data };
        case actionTypes.LIST_ROLES_ERROR:
            return { ...state, data: [], error: action.payload };
        default:
            return state
    }
}
// listLanguages
